import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";
import "./hm-theme.css";

const AddAgesPopup = ({ isOpen, onRequestClose, des }) => {
  const navigate = useNavigate();
  const [selectedAges, setSelectedAges] = useState([]);
  const [loading, setLoading] = useState(false);

  const ageOptions = Array.from({ length: 83 }, (_, i) => 18 + i);

  const toggleAgeSelection = (age) => {
    setSelectedAges((prevSelected) =>
      prevSelected.includes(age)
        ? prevSelected.filter((a) => a !== age)
        : [...prevSelected, age]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedAges.length === 0) {
      toast.warn("Please select at least one age.");
      return;
    }
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data"))?.token;

    const payload = selectedAges.map((age) => ({
      packageid: des?.pkg?.packageid,
      designationid: des?.designation?.designationId,
      gender: des?.gender,
      age,
    }));

    try {
      await axios.post("/api/packagedesignationmapping/create", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Ages added successfully");
      setSelectedAges([]);
      onRequestClose();
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleError = (error) => {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">cake</i>
          Add Ages to Package Mapping
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3 p-3 rounded-3 bg-light border">
            <div className="row g-2 small">
              <div className="col-6">
                <span className="text-muted d-block">Designation:</span>
                <strong>{des?.designation?.designation || "N/A"}</strong>
              </div>
              <div className="col-6">
                <span className="text-muted d-block">Gender:</span>
                <strong>{des?.gender || "N/A"}</strong>
              </div>
              <div className="col-12 mt-2">
                <span className="text-muted d-block">Package:</span>
                <strong>{des?.pkg?.pac?.packagename || "N/A"}</strong>
              </div>
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label small fw-semibold">
              Select Age(s) <span className="text-danger">*</span>
            </label>
            <div className="dropdown">
              <button
                className="form-control text-start dropdown-toggle bg-white d-flex align-items-center justify-content-between"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="text-truncate" style={{ maxWidth: "90%" }}>
                  {selectedAges.length > 0
                    ? selectedAges.sort((a, b) => a - b).join(", ")
                    : "Select Age(s)"}
                </span>
              </button>
              <ul
                className="dropdown-menu p-2 shadow-sm"
                style={{
                  maxHeight: "220px",
                  overflowY: "auto",
                  width: "100%",
                }}
              >
                {ageOptions.map((age) => (
                  <li key={age} className="form-check py-1 px-2">
                    <input
                      className="form-check-input ms-0 me-2"
                      type="checkbox"
                      value={age}
                      id={`age-${age}`}
                      checked={selectedAges.includes(age)}
                      onChange={() => toggleAgeSelection(age)}
                    />
                    <label
                      className="form-check-label small"
                      htmlFor={`age-${age}`}
                      style={{ cursor: "pointer" }}
                    >
                      {age} years
                    </label>
                  </li>
                ))}
              </ul>
            </div>
            {selectedAges.length > 0 && (
              <span className="small text-primary mt-1 d-block fw-semibold">
                {selectedAges.length} age(s) selected
              </span>
            )}
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>add</i>
              Save Ages
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddAgesPopup;
